export enum PrismPlugin {
  LineHighlight = 'line-highlight',
  LineNumbers = 'line-numbers',
}
